import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [gebruiker, setGebruiker] = useState(null);
  const [laden, setLaden]         = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('alyden_token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get('/api/auth/mij')
        .then(res => setGebruiker(res.data.gebruiker))
        .catch(() => {
          localStorage.removeItem('alyden_token');
          delete axios.defaults.headers.common['Authorization'];
        })
        .finally(() => setLaden(false));
    } else {
      setLaden(false);
    }
  }, []);

  async function login(email, wachtwoord, twofaCode = null, onthoudApparaat = false, onthoudToken = null) {
    const headers = {};
    if (onthoudToken) headers['x-onthoud-token'] = onthoudToken;

    const res = await axios.post('/api/auth/login',
      { email, wachtwoord, twofaCode, onthoudApparaat },
      { headers }
    );

    if (res.data.twofa_vereist) return { twofa_vereist: true };

    const { token, onthoud_token } = res.data;
    localStorage.setItem('alyden_token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    const mijRes = await axios.get('/api/auth/mij');
    setGebruiker(mijRes.data.gebruiker);

    // Geef onthoud_token terug zodat Login.js het kan opslaan
    return { ...mijRes.data.gebruiker, onthoud_token };
  }

  async function herlaadGebruiker() {
    try {
      const res = await axios.get('/api/auth/mij');
      setGebruiker(res.data.gebruiker);
      return res.data.gebruiker;
    } catch { return null; }
  }

  async function uitloggen() {
    try { await axios.post('/api/auth/uitloggen'); } catch { }
    localStorage.removeItem('alyden_token');
    // Onthoud token bewaren zodat 30-dagen bij volgende login werkt
    delete axios.defaults.headers.common['Authorization'];
    setGebruiker(null);
  }

  function heeftPermissie(code) {
    if (!gebruiker?.permissies) return false;
    return gebruiker.permissies.includes(code) || gebruiker.permissies.includes('superadmin.alles');
  }

  function heeftModule(code) {
    if (!gebruiker) return false;
    if (gebruiker.permissies?.includes('superadmin.alles')) return true;
    return gebruiker.modules?.includes(code) || false;
  }

  return (
    <AuthContext.Provider value={{ gebruiker, laden, login, uitloggen, heeftPermissie, heeftModule, herlaadGebruiker }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth moet binnen AuthProvider gebruikt worden');
  return ctx;
}
